import {
  AssignFileAsConsentFormArgs,
  DownloadConsentFormPdfArgs,
  SignConsentFormArgs,
  UploadSignedConsentFormArgs,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../backend/functions/functions'

export const signConsentForm = httpsCallable<SignConsentFormArgs>(functions, 'signConsentForm')
export const downloadConsentFormPdf = httpsCallable<DownloadConsentFormPdfArgs>(
  functions,
  'downloadConsentFormPdf',
)
export const uploadSignedConsentForm = httpsCallable<UploadSignedConsentFormArgs>(
  functions,
  'uploadSignedConsentForm',
)
export const assignFileAsConsentForm = httpsCallable<AssignFileAsConsentFormArgs>(
  functions,
  'assignFileAsConsentForm',
)
export const regenerateConsentFormPdf = httpsCallable<{
  consentFormId: string
  patientId: string
}>(functions, 'regenerateConsentFormPdf')
